import React from "react";
import ViewVacationBeingHere from "../component/VacationBeingHere/ViewVacationBeingHere";

const VacationBeingHere = () => {
  return (
    <>
      <ViewVacationBeingHere />
    </>
  );
};

export default VacationBeingHere;
